import React from 'react';

export const UserIcon = (props: any) => {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.82663 9.97345C9.34939 9.97345 11.3945 7.92835 11.3945 5.40558C11.3945 2.88282 9.34939 0.837723 6.82663 0.837723C4.30387 0.837723 2.25879 2.88282 2.25879 5.40558C2.25879 7.92835 4.30387 9.97345 6.82663 9.97345Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M0.386719 16.7129C0.386719 12.9688 3.38204 9.97345 7.12619 9.97345C10.8703 9.97345 13.8657 12.9688 13.8657 16.7129H0.386719Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
